import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImpressaoEventService {

  public onImpressorasListadas$ = new Subject<string[]>();

}
